import { Box } from "@mui/material";
import { useTheme } from "@mui/material";

import { colors } from "@/Utils";

export const Wrapper = ({ scroll, wrapperWidth, children, ...props }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        overflowX: scroll ? "scroll" : "auto",
        paddingBottom: scroll ? "30px" : "auto",
        width: wrapperWidth ? wrapperWidth : "100%",
        display: "flex",
        flexDirection: "column",
        minHeight: "200px",
        "&::-webkit-scrollbar": {
          height: "9px",
          cursor: "pointer",
        },
        "&::-webkit-scrollbar-track": {
          WebkitBoxShadow:
            theme.palette.mode === "light"
              ? "inset 0 0 30px #f4f4f4"
              : `inset 0 0 30px ${colors.lightBlack}`,
          borderRadius: "3px",
          marginLeft: "16px",
        },
        "&::-webkit-scrollbar-thumb": {
          borderRadius: "3px",
          width: "5px",
          WebkitWidth: 5,
          height: "5px",
          WebkitHeight: 5,
          WebkitBoxShadow: `inset 30 0 0px ${colors.bodyMain}`,
          background: theme.palette.mode === "light" ? colors.darkWhite : colors.textMain,
          cursor: "pointer",
        },
      }}
      {...props}
    >
      {children}
    </Box>
  );
};

export const FilterHeader = ({ children, ...props }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: "18px",
      }}
      {...props}
    >
      {children}
    </Box>
  );
};

export const FilterBody = ({ children, ...props }) => {
  return (
    <Box
      sx={{
        maxHeight: "200px",
        overflowY: "auto",
        marginLeft: "5px",
      }}
      {...props}
    >
      {children}
    </Box>
  );
};

export const TableWrapper = ({ children, ...props }) => {
  return (
    <Box
      sx={{
        width: "24px",
        height: "24px",
        position: "relative",
      }}
      {...props}
    >
      {children}
    </Box>
  );
};

export const FilterIconWrap = ({ children, ...props }) => {
  return <Box {...props}>{children}</Box>;
};

export const ControlWrap = ({ children, ...props }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-end",
        alignItems: "center",
        marginRight: "20px",
        marginBottom: "-20px",
      }}
      {...props}
    >
      {children}
    </Box>
  );
};
